import React from 'react';
import { NavLink } from 'react-router-dom';
import { HomeIcon, TruckIcon, LifeBuoyIcon, UserIcon, LogOutIcon, MapPinIcon, FileTextIcon, BuildingIcon } from 'lucide-react';
interface SidebarProps {
  onLogout: () => void;
}
const Sidebar: React.FC<SidebarProps> = ({
  onLogout
}) => {
  const navItems = [{
    name: 'Dashboard',
    path: '/dashboard',
    icon: <HomeIcon size={20} data-id="element-90" />
  }, {
    name: 'Quotes',
    path: '/quotes',
    icon: <FileTextIcon size={20} data-id="element-91" />
  }, {
    name: 'Shipments',
    path: '/shipments',
    icon: <TruckIcon size={20} data-id="element-92" />
  }, {
    name: 'Locations',
    path: '/locations',
    icon: <MapPinIcon size={20} data-id="element-93" />
  }, {
    name: 'Support',
    path: '/support',
    icon: <LifeBuoyIcon size={20} data-id="element-94" />
  }];
  return <div className="flex flex-col h-full bg-white" data-id="element-95">
      {/* Logo */}
      <div className="flex-shrink-0 px-4 py-5 border-b border-gray-100" data-id="element-96">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fToFbNCvyJK8ocv4pQiJPy/ThePoint_LogoMark_Horizontal_RGB_Final.png" alt="The Point TMS" className="h-6 w-auto" data-id="element-97" />
      </div>
      {/* Main Navigation */}
      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto" data-id="element-98">
        {navItems.map(item => <NavLink key={item.path} to={item.path} className={({
        isActive
      }) => `flex items-center px-4 py-2.5 text-sm font-medium rounded-lg transition-colors ${isActive ? 'bg-primary-50 text-primary-700' : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-99">
            <span className="flex-shrink-0" data-id="element-100">{item.icon}</span>
            <span className="ml-3" data-id="element-101">{item.name}</span>
          </NavLink>)}
      </nav>
      {/* User Actions */}
      <div className="flex-shrink-0 px-3 py-4 bg-gray-50" data-id="element-102">
        <NavLink to="/organization" className={({
        isActive
      }) => `flex items-center px-4 py-2.5 text-sm font-medium rounded-lg transition-colors ${isActive ? 'bg-primary-50 text-primary-700' : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-103">
          <span className="flex-shrink-0" data-id="element-104">
            <BuildingIcon size={20} data-id="element-105" />
          </span>
          <span className="ml-3" data-id="element-106">Organization</span>
        </NavLink>
        <NavLink to="/profile" className={({
        isActive
      }) => `flex items-center px-4 py-2.5 text-sm font-medium rounded-lg transition-colors ${isActive ? 'bg-primary-50 text-primary-700' : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-107">
          <span className="flex-shrink-0" data-id="element-108">
            <UserIcon size={20} data-id="element-109" />
          </span>
          <span className="ml-3" data-id="element-110">Profile</span>
        </NavLink>
        <button onClick={onLogout} className="w-full mt-1 flex items-center px-4 py-2.5 text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 hover:text-gray-900 transition-colors" data-id="element-111">
          <span className="flex-shrink-0" data-id="element-112">
            <LogOutIcon size={20} data-id="element-113" />
          </span>
          <span className="ml-3" data-id="element-114">Sign Out</span>
        </button>
      </div>
    </div>;
};
export default Sidebar;